import { render, staticRenderFns } from "./GraphTopFeatures.vue?vue&type=template&id=236d997e&"
import script from "./GraphTopFeatures.vue?vue&type=script&lang=js&"
export * from "./GraphTopFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports